/**
 * The Colyseus client singleton (frontend.md §1.3).
 *
 * The endpoint is derived from `location` at call time, never baked in: nginx
 * serves the SPA and proxies `/ws` on the same hostname, so one built image runs
 * on any domain. That is the same single-origin decision that lets the refresh
 * token be a `SameSite=Lax` cookie (§7.1).
 */

import { Client } from 'colyseus.js';

import { runtimeConfig } from '../config';

// Re-exported rather than redeclared: the matchmaker names are m3-server's
// `gameServer.define()` calls, and a second copy of the string here is exactly
// the drift `@ordago/shared` exists to prevent.
export { LOBBY_ROOM_NAME, MUS_ROOM_NAME } from '@ordago/shared';

export function wsEndpoint(): string {
  const scheme = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${scheme}//${window.location.host}${runtimeConfig.wsPath}`;
}

let client: Client | null = null;

/** Lazy so `wsEndpoint()` reads the real `location`, not a test's initial one. */
export function colyseus(): Client {
  client ??= new Client(wsEndpoint());
  return client;
}
